import { Scene } from '@babylonjs/core';

export class BaseStage {
    protected scene: Scene;
    constructor(scene: Scene) {
        this.scene = scene;
    }
    public onViewAngleChanged(data:any) {
    }
    public onCamChanged(data:any) {
    }
    public onWorkshopChanged(data:any) {
    }
    public createFancility(){}
    public reload() {
    }
    public unload() {
    }
}